export const MOCK_ORDERS = [
  {
    id: 101,
    po_number: "NCE-PO#26102",
    po_nce: "NPO#26-0594",
    company: "WEICHANG ALUMINIUM",
    goods_description: "ALUMINIUM PROFILE FOR SELMA SITE",
    status: "UNDER_PRODUCTION",
    status_label: "Manufacturing",
    sheet_type: "NOBLE",
    year: 2026,
    urgent_action: false,
    order_mail_date: "2026-07-17",
    quote_sent_date: "2026-07-22",
    quote_received_date: "2026-07-27",
    pi_confirmed_date: "2026-08-12",
    payment_date: "2026-08-13",
    balance_payment_date: null,
    eta_date: "2026-09-15",
    freight_type: "Sea Freight",
    remark: "PIP & Under Production",
    org_name: "Noblecon",
    consignee: "NOBLECON ENTERPRISE",
  },
  {
    id: 102,
    po_number: "NCE-PO#26106",
    po_nce: "NPO#26-0598",
    company: "INDIAN OCEAN COMMODITY TRADING FZC",
    goods_description: "REBAR STEEL T16 & T12",
    status: "UNDER_PRODUCTION",
    status_label: "Manufacturing",
    sheet_type: "NOBLE",
    year: 2026,
    urgent_action: true,
    order_mail_date: "2026-07-20",
    quote_sent_date: "2026-07-22",
    quote_received_date: "2026-07-22",
    pi_confirmed_date: "2026-07-27",
    payment_date: null,
    balance_payment_date: null,
    eta_date: "2026-09-08",
    freight_type: "Sea Freight",
    remark: "Urgent shipment required for Perseverance site",
    org_name: "Noblecon",
    consignee: "NOBLECON ENTERPRISE",
  },
  {
    id: 103,
    po_number: "SHJ-PO#26044",
    po_nce: "SPO#26-0112",
    company: "SAHAJANAND TRADING PTY",
    goods_description: "CERAMIC FLOOR TILES & ADHESIVE",
    status: "PI_CONFIRMED",
    status_label: "Confirm-Quote / PI",
    sheet_type: "SAHAJANAND",
    year: 2026,
    urgent_action: false,
    order_mail_date: "2026-07-28",
    quote_sent_date: "2026-07-28",
    quote_received_date: "2026-07-31",
    pi_confirmed_date: "2026-08-12",
    payment_date: "2026-08-15",
    balance_payment_date: null,
    eta_date: "2026-09-22",
    freight_type: "Sea Freight",
    remark: "PI confirmed and ready for production",
    org_name: "Sahajanand",
    consignee: "SAHAJANAND",
  },
  {
    id: 104,
    po_number: "SAHAJ#250609",
    po_nce: "NPO#25-403",
    company: "AL RABIH GENERAL TRADING",
    goods_description: "WELDMESH MESH FABRIC",
    status: "RECEIVED",
    status_label: "Received",
    sheet_type: "SAHAJ",
    year: 2025,
    urgent_action: false,
    order_mail_date: "2025-06-09",
    quote_sent_date: "2025-06-10",
    quote_received_date: "2025-06-11",
    pi_confirmed_date: "2025-06-26",
    payment_date: "2025-07-02",
    balance_payment_date: "2025-07-10",
    eta_date: "2025-07-15",
    freight_type: "Sea Way",
    remark: "Received at Providence Warehouse",
    org_name: "Sahaj Construction",
    consignee: "SAHAJ CONSTRUCTION",
  },
  {
    id: 105,
    po_number: "SAHAJ#250405",
    po_nce: "NPO#25-363",
    company: "VISAKA INDUSTRIES",
    goods_description: "CEMENT BOARD 6MM & 9MM",
    status: "READY_TO_LOAD",
    status_label: "Ready to Load",
    sheet_type: "SAHAJ",
    year: 2025,
    urgent_action: true,
    order_mail_date: "2025-04-05",
    quote_sent_date: "2025-04-05",
    quote_received_date: "2025-04-07",
    pi_confirmed_date: "2025-04-07",
    payment_date: "2025-04-10",
    balance_payment_date: null,
    eta_date: "2025-05-18",
    freight_type: "Sea Way",
    remark: "Waiting container booking at Mundra port",
    org_name: "Sahaj Construction",
    consignee: "SAHAJ CONSTRUCTION",
  },
  {
    id: 106,
    po_number: "NCE-PO#26119",
    po_nce: "NPO#26-0608",
    company: "ZHEJIANG DOUBLE-LIN VALVES CO., LTD",
    goods_description: "COPPER & BRASS FITTINGS",
    status: "QUOTE_SENT",
    status_label: "Asked for Quote",
    sheet_type: "NOBLE",
    year: 2026,
    urgent_action: false,
    order_mail_date: "2026-07-31",
    quote_sent_date: "2026-07-31",
    quote_received_date: null,
    pi_confirmed_date: null,
    payment_date: null,
    balance_payment_date: null,
    eta_date: "2026-10-05",
    freight_type: "Sea Freight",
    remark: "Waiting for quotation response",
    org_name: "Noblecon",
    consignee: "NOBLECON ENTERPRISE",
  },
  {
    id: 107,
    po_number: "SHJ-PO#26052",
    po_nce: "SPO#26-0120",
    company: "CHAOZHOU YUEJIE TECHNOLOGY CO LTD",
    goods_description: "TOILET & BATHROOM FIXTURES",
    status: "PENDING",
    status_label: "Request (Pending)",
    sheet_type: "SAHAJANAND",
    year: 2026,
    urgent_action: true,
    order_mail_date: "2026-08-05",
    quote_sent_date: null,
    quote_received_date: null,
    pi_confirmed_date: null,
    payment_date: null,
    balance_payment_date: null,
    eta_date: "2026-10-20",
    freight_type: "Sea Freight",
    remark: "Pending specification confirmation from site engineer",
    org_name: "Sahajanand",
    consignee: "SAHAJANAND",
  },
];

export const STATUS_PIPELINE = [
  {
    id: 1,
    key: "DRAFT",
    code: "DRAFT",
    name: "Draft",
    label: "Draft",
    shortLabel: "Draft",
    sequence_order: 1,
    progress: 5,
    color: "bg-slate-400",
    badgeColor: "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
    badge_color: "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700"
  },
  {
    id: 2,
    key: "SUBMITTED",
    code: "SUBMITTED",
    name: "Submitted",
    label: "Submitted",
    shortLabel: "Submitted",
    sequence_order: 2,
    progress: 10,
    color: "bg-blue-400",
    badgeColor: "bg-blue-100 text-blue-700 border-blue-300 dark:bg-blue-900/50 dark:text-blue-300 dark:border-blue-700",
    badge_color: "bg-blue-100 text-blue-700 border-blue-300 dark:bg-blue-900/50 dark:text-blue-300 dark:border-blue-700"
  },
  {
    id: 3,
    key: "SOURCING",
    code: "SOURCING",
    name: "Sourcing",
    label: "Sourcing",
    shortLabel: "Sourcing",
    sequence_order: 3,
    progress: 20,
    color: "bg-indigo-400",
    badgeColor: "bg-indigo-100 text-indigo-700 border-indigo-300 dark:bg-indigo-900/50 dark:text-indigo-300 dark:border-indigo-700",
    badge_color: "bg-indigo-100 text-indigo-700 border-indigo-300 dark:bg-indigo-900/50 dark:text-indigo-300 dark:border-indigo-700"
  },
  {
    id: 4,
    key: "ORDERED",
    code: "ORDERED",
    name: "Ordered",
    label: "Ordered",
    shortLabel: "Ordered",
    sequence_order: 4,
    progress: 40,
    color: "bg-purple-500",
    badgeColor: "bg-purple-100 text-purple-700 border-purple-300 dark:bg-purple-900/50 dark:text-purple-300 dark:border-purple-700",
    badge_color: "bg-purple-100 text-purple-700 border-purple-300 dark:bg-purple-900/50 dark:text-purple-300 dark:border-purple-700"
  },
  {
    id: 5,
    key: "IN_PRODUCTION",
    code: "IN_PRODUCTION",
    name: "In Production",
    label: "In Production",
    shortLabel: "In Production",
    sequence_order: 5,
    progress: 55,
    color: "bg-orange-500",
    badgeColor: "bg-orange-100 text-orange-800 border-orange-300 dark:bg-orange-950/60 dark:text-orange-300 dark:border-orange-800",
    badge_color: "bg-orange-100 text-orange-800 border-orange-300 dark:bg-orange-950/60 dark:text-orange-300 dark:border-orange-800"
  },
  {
    id: 6,
    key: "READY",
    code: "READY",
    name: "Ready",
    label: "Ready",
    shortLabel: "Ready",
    sequence_order: 6,
    progress: 70,
    color: "bg-yellow-500",
    badgeColor: "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-950/60 dark:text-yellow-300 dark:border-yellow-800",
    badge_color: "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-950/60 dark:text-yellow-300 dark:border-yellow-800"
  },
  {
    id: 7,
    key: "PACKED",
    code: "PACKED",
    name: "Packed",
    label: "Packed",
    shortLabel: "Packed",
    sequence_order: 7,
    progress: 78,
    color: "bg-lime-500",
    badgeColor: "bg-lime-100 text-lime-800 border-lime-300 dark:bg-lime-950/60 dark:text-lime-300 dark:border-lime-800",
    badge_color: "bg-lime-100 text-lime-800 border-lime-300 dark:bg-lime-950/60 dark:text-lime-300 dark:border-lime-800"
  },
  {
    id: 8,
    key: "SHIPPED",
    code: "SHIPPED",
    name: "Shipped",
    label: "Shipped",
    shortLabel: "Shipped",
    sequence_order: 8,
    progress: 85,
    color: "bg-cyan-500",
    badgeColor: "bg-cyan-100 text-cyan-800 border-cyan-300 dark:bg-cyan-950/60 dark:text-cyan-300 dark:border-cyan-800",
    badge_color: "bg-cyan-100 text-cyan-800 border-cyan-300 dark:bg-cyan-950/60 dark:text-cyan-300 dark:border-cyan-800"
  },
  {
    id: 9,
    key: "ARRIVED",
    code: "ARRIVED",
    name: "Arrived",
    label: "Arrived",
    shortLabel: "Arrived",
    sequence_order: 9,
    progress: 92,
    color: "bg-blue-600",
    badgeColor: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800",
    badge_color: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800"
  },
  {
    id: 10,
    key: "RECEIVED",
    code: "RECEIVED",
    name: "Received",
    label: "Received",
    shortLabel: "Received",
    sequence_order: 10,
    progress: 96,
    color: "bg-emerald-500",
    badgeColor: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800",
    badge_color: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800"
  },
  {
    id: 11,
    key: "COMPLETED",
    code: "COMPLETED",
    name: "Completed",
    label: "Completed",
    shortLabel: "Completed",
    sequence_order: 11,
    progress: 100,
    color: "bg-emerald-600",
    badgeColor: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800",
    badge_color: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800"
  },
  {
    id: 12,
    key: "CANCELLED",
    code: "CANCELLED",
    name: "Cancelled",
    label: "Cancelled",
    shortLabel: "Cancelled",
    sequence_order: 12,
    progress: 0,
    color: "bg-red-500",
    badgeColor: "bg-red-100 text-red-800 border-red-300 dark:bg-red-950/60 dark:text-red-300 dark:border-red-800",
    badge_color: "bg-red-100 text-red-800 border-red-300 dark:bg-red-950/60 dark:text-red-300 dark:border-red-800"
  },
  {
    id: 13,
    key: "DEFECT_REOPENED",
    code: "DEFECT_REOPENED",
    name: "Defect / Reopened",
    label: "Defect / Reopened",
    shortLabel: "Defect",
    sequence_order: 13,
    progress: 95,
    color: "bg-rose-500",
    badgeColor: "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-800",
    badge_color: "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-800"
  }
];

export function getVisibleStages() {
  return STATUS_PIPELINE;
}
